module.exports = __webpack_public_path__ + "static/media/evolution_92.a5733526.svg";